import styled from 'styled-components'

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5%;
  height: 100%;
  width: 100%;
`

export const Left = styled.div`
  width: 20%;
  height: 100%;
  margin: 5px;
  display: flex;
  align-items: center;

  @media (width: '600px') {
    width: 10%;
  }
`

export const Right = styled.div`
  width: 20%;
  @media (width: '600px') {
    width: 10%;
  }
`

export const Center = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  animation: all 5s ease-in-out;
`

export const ImgLogo = styled.img`
  object-fit: contain;
`
export const BackToList = styled.div`
  padding-left: 10px;
  width: 50px;
`
export const ThemeSwitch = styled.div`
  width: 50px;
`
